"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledUpsell = void 0;
var _Upsell = require("./Upsell");
// TODO: in v9, move styled() from Upsell.jsx to here
var StyledUpsell = _Upsell.Upsell;
exports.StyledUpsell = StyledUpsell;